<h4>Existing users, if any, and their assigned sections.</h4>

<nz-table #basicTable [nzData]="usersAndEmails">
	<thead>
		<tr>
			<th
				[nzChecked]="checked"
				[nzIndeterminate]="indeterminate"
				nzLabel="Select all"
				(nzCheckedChange)="onAllChecked($event)"
			></th>
			<th>User</th>
			<th>Sections</th>
		</tr>
	</thead>
	<tbody>
		@for (data of basicTable.data; track data) {
			<tr>
				<td
					[nzChecked]="selectedEmails.has(data.email)"
					[nzLabel]="data.email"
					(nzCheckedChange)="onItemChecked(data.email, $event)"
				></td>
				<td>{{ data.email }}</td>
				<td>{{ prettySections(data.user.user_section || []) }}</td>
			</tr>
		}
	</tbody>
</nz-table>

<br />

<div class="buttons">
	<button
		(click)="clearSectionsFromSelectedUsers()"
		nz-button
		nzType="default"
		[disabled]="selectedEmails.size === 0"
	>
		Clear sections from {{ selectedEmails.size }} selected users
	</button>
	<button (click)="continue()" nz-button nzType="primary">Continue to create new users</button>
</div>
